/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expand_TitleInputs */

const en_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand Event Text`)
};

const fr_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elargir le Texte de l'Evenement`)
};

const de_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext erweitern`)
};

const it_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandi il testo dell'evento`)
};

const ru_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развернуть текст события`)
};

const es_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir texto del evento`)
};

const zh_cn2_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展开事件文本`)
};

const ja_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストを展開`)
};

const hi_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट का विस्तार करें`)
};

const pt_pt2_expand_title = /** @type {(inputs: Expand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir texto do evento`)
};

/**
* | output |
* | --- |
* | "Expand Event Text" |
*
* @param {Expand_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const expand_title = /** @type {((inputs?: Expand_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expand_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_expand_title(inputs)
	if (locale === "de") return de_expand_title(inputs)
	if (locale === "it") return it_expand_title(inputs)
	if (locale === "ru") return ru_expand_title(inputs)
	if (locale === "es") return es_expand_title(inputs)
	if (locale === "zh-CN") return zh_cn2_expand_title(inputs)
	if (locale === "ja") return ja_expand_title(inputs)
	if (locale === "hi") return hi_expand_title(inputs)
	if (locale === "pt-PT") return pt_pt2_expand_title(inputs)
	return en_expand_title(inputs)
});